import { DateTime } from "luxon"
import { ExtendedDynamicConfigKey, InputField, SelectValue } from "./formTypes"

export function applyFieldFallback(
    acc: Partial<Record<ExtendedDynamicConfigKey, any>>,
    inputField: InputField,
    key: ExtendedDynamicConfigKey,
    selectValues?: SelectValue[],
): void {
    if (inputField.predefined?.value !== undefined) {
        acc[key] = inputField.predefined.value
    } else if (inputField.data === "text") {
        acc[key] = ""
    } else if (inputField.type === "number") {
        acc[key] = undefined
    } else if (inputField.type === "checkbox" || inputField.type === "toogle") {
        acc[key] = false
    } else if (inputField.type === "dateTimePicker") {
        acc[key] = DateTime.now()
    } else if (inputField.type === "select" && selectValues) {
        const prefilled = selectValues.find((o) => o.isPrefilled)?.value
        acc[key] = prefilled ?? null
    }
}
